import { useState, useRef, useEffect, useCallback } from 'react';
import {
  Bot, Send, PlusCircle, Trash2, ChevronDown,
  Upload, X, FileText, Image as ImageIcon, Video,
  Zap, Building2, Globe, CheckCircle, AlertCircle,
  Loader, ExternalLink, LogOut, Key,
} from 'lucide-react';
import * as blotato from './api/blotatoApi';
import { fetchClients, createClient, deleteClient } from './api/clientsApi';
import LoginPage from './LoginPage';
import './App.css';

// ── Constants ─────────────────────────────────────────────────────────────────

const SOCIAL_PLATFORMS = [
  {
    id: 'x', label: 'X (Twitter)', color: '#000000',
    Icon: () => (
      <svg viewBox="0 0 24 24" fill="currentColor" width="16" height="16">
        <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-4.714-6.231-5.401 6.231H2.746l7.73-8.835L1.254 2.25H8.08l4.253 5.622zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
      </svg>
    ),
  },
  {
    id: 'linkedin', label: 'LinkedIn', color: '#0A66C2',
    Icon: () => (
      <svg viewBox="0 0 24 24" fill="currentColor" width="16" height="16">
        <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
      </svg>
    ),
  },
  {
    id: 'facebook', label: 'Facebook', color: '#1877F2',
    Icon: () => (
      <svg viewBox="0 0 24 24" fill="currentColor" width="16" height="16">
        <path d="M24 12.073C24 5.405 18.627 0 12 0S0 5.405 0 12.073C0 18.1 4.388 23.094 10.125 24v-8.437H7.078v-3.49h3.047V9.41c0-3.025 1.792-4.697 4.533-4.697 1.312 0 2.686.235 2.686.235v2.97h-1.513c-1.491 0-1.956.93-1.956 1.883v2.286h3.328l-.532 3.49h-2.796V24C19.612 23.094 24 18.1 24 12.073z"/>
      </svg>
    ),
  },
  {
    id: 'tiktok', label: 'TikTok', color: '#010101',
    Icon: () => (
      <svg viewBox="0 0 24 24" fill="currentColor" width="16" height="16">
        <path d="M12.525.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.07-.14 1.61.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.02-12.07z"/>
      </svg>
    ),
  },
  {
    id: 'instagram', label: 'Instagram', color: '#E1306C',
    Icon: () => (
      <svg viewBox="0 0 24 24" fill="currentColor" width="16" height="16">
        <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
      </svg>
    ),
  },
  {
    id: 'threads', label: 'Threads', color: '#000000',
    Icon: () => (
      <svg viewBox="0 0 24 24" fill="currentColor" width="16" height="16">
        <path d="M12.186 24h-.007c-3.581-.024-6.334-1.205-8.184-3.509C2.35 18.44 1.5 15.586 1.472 12.01v-.017c.03-3.579.879-6.43 2.525-8.482C5.845 1.205 8.6.024 12.18 0h.014c2.746.02 5.043.725 6.826 2.098 1.677 1.29 2.858 3.13 3.509 5.467l-2.04.569c-1.104-3.96-3.898-5.984-8.304-6.015-2.91.022-5.11.936-6.54 2.717C4.307 6.504 3.616 8.914 3.589 12c.027 3.086.718 5.496 2.057 7.164 1.43 1.783 3.631 2.698 6.54 2.717 2.623-.02 4.358-.631 5.689-2.073 1.163-1.26 1.819-3.188 1.974-5.62H12.18v-2.101h9.476c.17 5.301-1.33 8.87-4.013 10.861C15.966 23.373 14.203 24 12.186 24zm4.562-13.98c-.18-1.193-.618-2.184-1.3-2.943-.807-.9-1.926-1.37-3.323-1.399-1.066.014-1.99.318-2.747.903-.757.585-1.27 1.42-1.523 2.482l-2.01-.457c.35-1.495 1.086-2.701 2.185-3.583 1.1-.882 2.457-1.342 4.032-1.367 1.938.035 3.497.695 4.633 1.963.993 1.107 1.584 2.582 1.757 4.4H16.748z"/>
      </svg>
    ),
  },
  {
    id: 'pinterest', label: 'Pinterest', color: '#E60023',
    Icon: () => (
      <svg viewBox="0 0 24 24" fill="currentColor" width="16" height="16">
        <path d="M12 0C5.373 0 0 5.372 0 12c0 5.084 3.163 9.426 7.627 11.174-.105-.949-.2-2.405.042-3.441.218-.937 1.407-5.965 1.407-5.965s-.359-.719-.359-1.782c0-1.668.967-2.914 2.171-2.914 1.023 0 1.518.769 1.518 1.69 0 1.029-.655 2.568-.994 3.995-.283 1.194.599 2.169 1.777 2.169 2.133 0 3.772-2.249 3.772-5.495 0-2.873-2.064-4.882-5.012-4.882-3.414 0-5.418 2.561-5.418 5.207 0 1.031.397 2.138.893 2.738a.36.36 0 01.083.345l-.333 1.36c-.053.22-.174.267-.402.161-1.499-.698-2.436-2.889-2.436-4.649 0-3.785 2.75-7.262 7.929-7.262 4.163 0 7.398 2.967 7.398 6.931 0 4.136-2.607 7.464-6.227 7.464-1.216 0-2.359-.632-2.75-1.378l-.748 2.853c-.271 1.043-1.002 2.35-1.492 3.146C9.57 23.812 10.763 24 12 24c6.627 0 12-5.373 12-12S18.627 0 12 0z"/>
      </svg>
    ),
  },
  {
    id: 'bluesky', label: 'Bluesky', color: '#0085FF',
    Icon: () => (
      <svg viewBox="0 0 24 24" fill="currentColor" width="16" height="16">
        <path d="M12 10.8c-1.087-2.114-4.046-6.053-6.798-7.995C2.566.944 1.561 1.266.902 1.565.139 1.908 0 3.08 0 3.768c0 .69.378 5.65.624 6.479.815 2.736 3.713 3.66 6.383 3.364.136-.02.275-.039.415-.056-.138.022-.276.04-.415.056-3.912.58-7.387 2.005-2.83 7.078 5.013 5.19 6.87-1.113 7.823-4.308.953 3.195 2.05 9.271 7.733 4.308 4.267-4.308 1.172-6.498-2.74-7.078a8.741 8.741 0 01-.415-.056c.14.017.279.036.415.056 2.67.297 5.568-.628 6.383-3.364.246-.828.624-5.79.624-6.478 0-.69-.139-1.861-.902-2.204-.659-.299-1.664-.62-4.3 1.24C16.046 4.748 13.087 8.687 12 10.8z"/>
      </svg>
    ),
  },
  {
    id: 'youtube', label: 'YouTube', color: '#FF0000',
    Icon: () => (
      <svg viewBox="0 0 24 24" fill="currentColor" width="16" height="16">
        <path d="M23.498 6.186a3.016 3.016 0 00-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 00.502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 002.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 002.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
      </svg>
    ),
  },
];

const CONTENT_TYPES = [
  { id: 'video',    label: 'Video',     Icon: Video },
  { id: 'image',    label: 'Image',     Icon: ImageIcon },
  { id: 'textfile', label: 'Text File', Icon: FileText },
  { id: 'pdf',      label: 'PDF',       Icon: FileText },
];

// ── Sub-components ────────────────────────────────────────────────────────────

function AddClientModal({ onAdd, onClose }) {
  const [name, setName]       = useState('');
  const [domain, setDomain]   = useState('');
  const [apiKey, setApiKey]   = useState('');
  const [saving, setSaving]   = useState(false);
  const [error, setError]     = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!name.trim()) return;
    setSaving(true);
    setError('');
    try {
      const client = await createClient({
        company_name:    name.trim(),
        domain:          domain.trim() || undefined,
        blotato_api_key: apiKey.trim() || undefined,
      });
      onAdd(client);
      onClose();
    } catch (err) {
      setError(err.response?.data?.error ?? 'Failed to save client');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h3>Add New Client</h3>
          <button className="icon-btn" onClick={onClose}><X size={18} /></button>
        </div>
        <form onSubmit={handleSubmit} className="modal-body">
          <label className="field-label">
            Company Name <span className="required">*</span>
            <div className="input-icon-wrap">
              <Building2 size={16} className="input-icon" />
              <input value={name} onChange={(e) => setName(e.target.value)} placeholder="e.g. Acme Corp" required autoFocus />
            </div>
          </label>
          <label className="field-label">
            Domain
            <div className="input-icon-wrap">
              <Globe size={16} className="input-icon" />
              <input value={domain} onChange={(e) => setDomain(e.target.value)} placeholder="e.g. acme.com" />
            </div>
          </label>
          <label className="field-label">
            Blotato API Key
            <div className="input-icon-wrap">
              <Key size={16} className="input-icon" />
              <input
                type="password"
                value={apiKey}
                onChange={(e) => setApiKey(e.target.value)}
                placeholder="blt_… (stored encrypted)"
              />
            </div>
          </label>
          {error && <div className="gen-error"><AlertCircle size={13} />{error}</div>}
          <div className="modal-actions">
            <button type="button" className="btn-secondary" onClick={onClose}>Cancel</button>
            <button type="submit" className="btn-primary" disabled={saving}>
              {saving ? 'Saving…' : 'Add Client'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

function ConfirmModal({ title, message, confirmLabel = 'Delete', onConfirm, onClose }) {
  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal confirm-modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h3>{title}</h3>
          <button className="icon-btn" onClick={onClose}><X size={18} /></button>
        </div>
        <div className="modal-body">
          <p className="confirm-message">{message}</p>
          <div className="modal-actions">
            <button className="btn-secondary" onClick={onClose}>Cancel</button>
            <button className="btn-danger" onClick={() => { onConfirm(); onClose(); }}>
              {confirmLabel}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

function FileChip({ file, onRemove }) {
  const isImage = file.type.startsWith('image/');
  const isVideo = file.type.startsWith('video/');
  const Icon = isImage ? ImageIcon : isVideo ? Video : FileText;
  return (
    <div className="file-chip">
      <Icon size={13} />
      <span className="chip-name">{file.name}</span>
      <button className="chip-remove" onClick={() => onRemove(file.name)}><X size={11} /></button>
    </div>
  );
}

function StepRow({ label, status, detail }) {
  return (
    <div className={`step-row step-${status}`}>
      <div className="step-icon">
        {status === 'pending'  && <div className="step-dot" />}
        {status === 'running'  && <Loader size={15} className="spin" />}
        {status === 'done'     && <CheckCircle size={15} />}
        {status === 'error'    && <AlertCircle size={15} />}
        {status === 'skipped'  && <div className="step-dot muted" />}
      </div>
      <div className="step-body">
        <span className="step-label">{label}</span>
        {detail && <span className="step-detail">{detail}</span>}
      </div>
    </div>
  );
}

function GenerateModal({ steps, result, error, onClose }) {
  const allDone  = steps.every((s) => s.status === 'done' || s.status === 'skipped');
  const hasFailed = steps.some((s) => s.status === 'error');

  return (
    <div className="modal-overlay" onClick={hasFailed || allDone ? onClose : undefined}>
      <div className="modal generate-modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h3>{hasFailed ? 'Generation failed' : allDone ? 'Done!' : 'Generating with Blotato…'}</h3>
          {(hasFailed || allDone) && <button className="icon-btn" onClick={onClose}><X size={18} /></button>}
        </div>
        <div className="modal-body generate-body">
          {steps.map((s) => <StepRow key={s.id} label={s.label} status={s.status} detail={s.detail} />)}
          {error && <div className="gen-error"><AlertCircle size={14} />{error}</div>}
          {allDone && result && (
            <div className="gen-result">
              {result.map((r) => (
                <div key={r.platform} className="result-row">
                  <CheckCircle size={14} className="result-check" />
                  <span>{r.platform}</span>
                  {r.publicUrl && (
                    <a href={r.publicUrl} target="_blank" rel="noreferrer" className="result-link">
                      View post <ExternalLink size={12} />
                    </a>
                  )}
                </div>
              ))}
            </div>
          )}
        </div>
        {(hasFailed || allDone) && (
          <div className="modal-actions" style={{ padding: '0 20px 20px' }}>
            <button className="btn-primary" style={{ marginLeft: 'auto' }} onClick={onClose}>Close</button>
          </div>
        )}
      </div>
    </div>
  );
}

// ── Generate step helpers ─────────────────────────────────────────────────────

const STEP_DEFS = [
  { id: 'accounts', label: 'Resolve connected accounts' },
  { id: 'upload',   label: 'Upload context files' },
  { id: 'video',    label: 'Generate video / visual' },
  { id: 'publish',  label: 'Publish to platforms' },
];

const makeSteps = () => STEP_DEFS.map((s) => ({ ...s, status: 'pending', detail: null }));

const updateStep = (setSteps, id, patch) =>
  setSteps((prev) => prev.map((s) => (s.id === id ? { ...s, ...patch } : s)));

// ── Main App ──────────────────────────────────────────────────────────────────

export default function App() {
  // Auth
  const [authUser, setAuthUser] = useState(() => {
    try { return JSON.parse(localStorage.getItem('auth_user')); } catch { return null; }
  });

  // Clients
  const [clients, setClients]               = useState([]);
  const [clientsLoading, setClientsLoading] = useState(false);
  const [selectedClientId, setSelectedClientId] = useState(null);
  const [showDropdown, setShowDropdown]     = useState(false);
  const [showAddClient, setShowAddClient]   = useState(false);

  // Sidebar settings
  const [contextFiles, setContextFiles]         = useState([]);
  const [selectedContentType, setSelectedContentType] = useState('');
  const [selectedPlatforms, setSelectedPlatforms]     = useState([]);

  // Chat
  const [messages, setMessages] = useState([
    { id: 1, role: 'assistant', text: 'Hello! Select a client and configure your content settings on the left, then chat with me to generate content ideas.' },
  ]);
  const [inputText, setInputText] = useState('');
  const fileInputRef = useRef(null);
  const chatEndRef   = useRef(null);

  // Generate modal
  const [genSteps,  setGenSteps]  = useState(null);
  const [genResult, setGenResult] = useState(null);
  const [genError,  setGenError]  = useState(null);

  // Confirm delete modal
  const [confirmDelete, setConfirmDelete] = useState(null); // { id, name }

  const selectedClient = clients.find((c) => c.id === selectedClientId);

  // ── Load clients from DB on mount ──
  const loadClients = useCallback(async () => {
    setClientsLoading(true);
    try {
      const list = await fetchClients();
      setClients(list);
      if (list.length && !selectedClientId) setSelectedClientId(list[0].id);
    } catch (err) {
      console.error('Failed to load clients:', err.message);
    } finally {
      setClientsLoading(false);
    }
  }, [selectedClientId]);

  useEffect(() => {
    if (authUser) loadClients();
  }, [authUser]); // eslint-disable-line react-hooks/exhaustive-deps

  // ── Auth ──
  const handleLogin = (user) => setAuthUser(user);

  const handleLogout = () => {
    localStorage.removeItem('auth_token');
    localStorage.removeItem('auth_user');
    setAuthUser(null);
    setClients([]);
    setSelectedClientId(null);
  };

  // ── Client management ──
  const handleAddClient = (newClient) => {
    setClients((prev) => [...prev, newClient]);
    setSelectedClientId(newClient.id);
  };

  const handleRemoveClient = async (id) => {
    try {
      await deleteClient(id);
      const remaining = clients.filter((c) => c.id !== id);
      setClients(remaining);
      if (selectedClientId === id) setSelectedClientId(remaining[0]?.id ?? null);
    } catch (err) {
      console.error('Failed to delete client:', err.message);
    }
  };

  // ── File handling ──
  const handleFileUpload = (e) => {
    const incoming = Array.from(e.target.files);
    setContextFiles((prev) => {
      const names = new Set(prev.map((f) => f.name));
      return [...prev, ...incoming.filter((f) => !names.has(f.name))];
    });
    e.target.value = '';
  };

  const handleDrop = (e) => {
    e.preventDefault();
    const incoming = Array.from(e.dataTransfer.files);
    setContextFiles((prev) => {
      const names = new Set(prev.map((f) => f.name));
      return [...prev, ...incoming.filter((f) => !names.has(f.name))];
    });
  };

  const removeFile = (name) => setContextFiles((prev) => prev.filter((f) => f.name !== name));

  const togglePlatform = (id) =>
    setSelectedPlatforms((prev) =>
      prev.includes(id) ? prev.filter((p) => p !== id) : [...prev, id]
    );

  // ── Chat ──
  const sendMessage = () => {
    const text = inputText.trim();
    if (!text) return;
    const userMsg = { id: Date.now(), role: 'user', text };
    const botMsg  = {
      id: Date.now() + 1,
      role: 'assistant',
      text: `Got it! I'll help generate content for ${selectedClient?.company_name ?? 'your client'}. Use the sidebar settings and hit "Generate with Blotato" when ready.`,
    };
    setMessages((prev) => [...prev, userMsg, botMsg]);
    setInputText('');
    setTimeout(() => chatEndRef.current?.scrollIntoView({ behavior: 'smooth' }), 50);
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); sendMessage(); }
  };

  // ── Generate ──
  const handleGenerate = async () => {
    if (!selectedClient) return alert('Please select a client first.');
    if (selectedPlatforms.length === 0) return alert('Please select at least one platform.');

    const steps = makeSteps();
    setGenSteps(steps);
    setGenResult(null);
    setGenError(null);
    const set = (id, patch) => updateStep(setGenSteps, id, patch);
    const cid = selectedClient.id;

    try {
      // Step 1: resolve accounts
      set('accounts', { status: 'running', detail: 'Fetching connected accounts…' });
      const { items: accounts } = await blotato.getAccounts(cid);
      const platformAccounts = {};
      for (const pid of selectedPlatforms) {
        const blotatoPlatform = pid === 'x' ? 'twitter' : pid;
        const match = accounts.find((a) => a.platform === blotatoPlatform);
        if (!match) throw new Error(`No connected ${pid} account found in Blotato.`);
        let pageId, boardId;
        if (pid === 'facebook' || pid === 'linkedin') {
          const { items: subs } = await blotato.getSubaccounts(cid, match.id);
          pageId = subs?.[0]?.id;
          if (pid === 'facebook' && !pageId) throw new Error('No Facebook page found under your account.');
        }
        if (pid === 'pinterest') {
          const { items: boards } = await blotato.getPinterestBoards(cid, match.id);
          boardId = boards?.[0]?.id;
          if (!boardId) throw new Error('No Pinterest board found under your account.');
        }
        platformAccounts[pid] = { accountId: match.id, pageId, boardId };
      }
      set('accounts', { status: 'done', detail: `${Object.keys(platformAccounts).length} account(s) resolved` });

      // Step 2: upload files
      let mediaUrls = [];
      const uploadable = contextFiles.filter((f) => f.type.startsWith('image/') || f.type.startsWith('video/'));
      if (uploadable.length > 0) {
        set('upload', { status: 'running', detail: `Uploading ${uploadable.length} file(s)…` });
        for (const file of uploadable) {
          const url = await blotato.uploadLocalFile(cid, file);
          mediaUrls.push(url);
        }
        set('upload', { status: 'done', detail: `${mediaUrls.length} file(s) uploaded` });
      } else {
        set('upload', { status: 'skipped', detail: 'No image/video files to upload' });
      }

      // Shared: grab the last user message as caption/prompt for both step 3 and 4
      const lastUserMsg = [...messages].reverse().find((m) => m.role === 'user');

      // Step 3: generate visual
      if (selectedContentType === 'video' || selectedContentType === 'image') {
        set('video', { status: 'running', detail: 'Fetching available templates…' });

        const templatesData = await blotato.listVideoTemplates(cid, selectedContentType);
        const templates = templatesData?.items ?? templatesData ?? [];
        if (!templates.length) {
          throw new Error('No video templates found in your Blotato account. Create one at my.blotato.com/videos first.');
        }
        const templateId = templates[0].id;
        set('video', { status: 'running', detail: `Using template: ${templates[0].name ?? templateId}` });

        const prompt = `Create a ${selectedContentType} for ${selectedClient.company_name}${selectedClient.domain ? ` (${selectedClient.domain})` : ''}. ${lastUserMsg?.text ?? ''}`.trim();
        const { item } = await blotato.createVideo(cid, { templateId, prompt });

        const done = await blotato.pollVideo(cid, item.id, {
          onStatus: (s) => set('video', { status: 'running', detail: `Status: ${s}` }),
        });
        if (done.mediaUrl)          mediaUrls = [done.mediaUrl, ...mediaUrls];
        if (done.imageUrls?.length) mediaUrls = [...done.imageUrls, ...mediaUrls];
        set('video', { status: 'done', detail: 'Visual ready' });
      } else {
        set('video', { status: 'skipped', detail: `Output type: "${selectedContentType || 'text'}"` });
      }

      // Step 4: publish
      set('publish', { status: 'running', detail: `Publishing to ${selectedPlatforms.join(', ')}…` });
      const caption = lastUserMsg?.text ?? `New post from ${selectedClient.company_name}`;

      const PLATFORM_MAP = {
        x: 'twitter', linkedin: 'linkedin', facebook: 'facebook',
        tiktok: 'tiktok', instagram: 'instagram', threads: 'threads',
        pinterest: 'pinterest', bluesky: 'bluesky', youtube: 'youtube',
      };

      const results = [];
      for (const pid of selectedPlatforms) {
        const { accountId, pageId } = platformAccounts[pid];
        const platformKey = PLATFORM_MAP[pid] ?? pid;
        set('publish', { status: 'running', detail: `Posting to ${pid}…` });

        const target =
          pid === 'facebook'  ? { targetType: 'facebook', pageId } :
          pid === 'tiktok'    ? { targetType: 'tiktok', privacyLevel: 'PUBLIC_TO_EVERYONE', disabledComments: false, disabledDuet: false, disabledStitch: false, isBrandedContent: false, isYourBrand: false, isAiGenerated: true } :
          pid === 'pinterest' ? { targetType: 'pinterest', boardId: platformAccounts[pid].boardId } :
          pid === 'youtube'   ? { targetType: 'youtube', title: caption.slice(0, 100), privacyStatus: 'public', shouldNotifySubscribers: true } :
          { targetType: platformKey };

        const { postSubmissionId } = await blotato.publishPost(cid, {
          post: {
            accountId,
            content: { text: caption, mediaUrls, platform: platformKey },
            target,
          },
        });

        const published = await blotato.pollPost(cid, postSubmissionId, {
          onStatus: (s) => set('publish', { status: 'running', detail: `${pid}: ${s}` }),
        });
        results.push({ platform: pid, publicUrl: published.publicUrl });
      }

      set('publish', { status: 'done', detail: `Published to ${results.length} platform(s)` });
      setGenResult(results);

      const urls = results.map((r) => r.publicUrl).filter(Boolean).join(', ');
      setMessages((prev) => [...prev, {
        id: Date.now(),
        role: 'assistant',
        text: `Published to ${results.map((r) => r.platform).join(', ')}!${urls ? ` Links: ${urls}` : ''}`,
      }]);
      setTimeout(() => chatEndRef.current?.scrollIntoView({ behavior: 'smooth' }), 50);

    } catch (err) {
      setGenSteps((prev) =>
        prev.map((s) => s.status === 'running' ? { ...s, status: 'error', detail: err.message } : s)
      );
      setGenError(err.message);
    }
  };

  // ── Auth gate ──
  if (!authUser) return <LoginPage onLogin={handleLogin} />;

  // ── Render ────────────────────────────────────────────────────────────────

  return (
    <div className="app" onClick={() => showDropdown && setShowDropdown(false)}>

      {/* ── Sidebar ── */}
      <aside className="sidebar">
        <div className="sidebar-logo">
          <Bot size={26} className="logo-icon" />
          <span>AI Agent</span>
        </div>

        {/* Client selector */}
        <section className="sidebar-section">
          <div className="section-label">Client</div>
          <div className="dropdown-wrap" onClick={(e) => e.stopPropagation()}>
            <button className="dropdown-trigger" onClick={() => setShowDropdown((v) => !v)}>
              <div className="client-preview">
                <Building2 size={15} />
                <div>
                  <div className="client-name">
                    {clientsLoading ? 'Loading…' : selectedClient?.company_name ?? 'Select client'}
                  </div>
                  {selectedClient?.domain && <div className="client-domain">{selectedClient.domain}</div>}
                </div>
              </div>
              <ChevronDown size={15} className={showDropdown ? 'chevron-open' : ''} />
            </button>

            {showDropdown && (
              <div className="dropdown-menu">
                {clients.map((c) => (
                  <div key={c.id} className={`dropdown-item ${c.id === selectedClientId ? 'active' : ''}`}>
                    <button
                      className="dropdown-item-main"
                      onClick={() => { setSelectedClientId(c.id); setShowDropdown(false); }}
                    >
                      <Building2 size={13} />
                      <div>
                        <div className="item-name">
                          {c.company_name}
                          {c.has_api_key ? <span className="key-dot" title="Has API key" /> : null}
                        </div>
                        {c.domain && <div className="item-domain">{c.domain}</div>}
                      </div>
                    </button>
                    <button
                      className="icon-btn danger"
                      title="Remove client"
                      onClick={() => { setShowDropdown(false); setConfirmDelete({ id: c.id, name: c.company_name }); }}
                    >
                      <Trash2 size={13} />
                    </button>
                  </div>
                ))}
                <button className="dropdown-add" onClick={() => { setShowDropdown(false); setShowAddClient(true); }}>
                  <PlusCircle size={13} /> Add Client
                </button>
              </div>
            )}
          </div>
        </section>

        {/* Context Files */}
        <section className="sidebar-section">
          <div className="section-label">Context Files</div>
          <div
            className="upload-zone"
            onClick={() => fileInputRef.current?.click()}
            onDragOver={(e) => e.preventDefault()}
            onDrop={handleDrop}
          >
            <Upload size={18} />
            <span>Click or drag files</span>
            <span className="upload-hint">PDF · Images · Videos</span>
          </div>
          <input ref={fileInputRef} type="file" multiple accept=".pdf,image/*,video/*" style={{ display: 'none' }} onChange={handleFileUpload} />
          {contextFiles.length > 0 && (
            <div className="file-list">
              {contextFiles.map((f) => <FileChip key={f.name} file={f} onRemove={removeFile} />)}
            </div>
          )}
        </section>

        {/* Output Type */}
        <section className="sidebar-section">
          <div className="section-label">Output Type</div>
          <div className="pill-grid">
            {CONTENT_TYPES.map(({ id, label, Icon }) => (
              <button key={id} className={`pill ${selectedContentType === id ? 'pill-active' : ''}`} onClick={() => setSelectedContentType((v) => (v === id ? '' : id))}>
                <Icon size={13} /> {label}
              </button>
            ))}
          </div>
        </section>

        {/* Post To */}
        <section className="sidebar-section">
          <div className="section-label">Post To</div>
          <div className="pill-grid">
            {SOCIAL_PLATFORMS.map(({ id, label, Icon, color }) => (
              <button
                key={id}
                className={`pill platform-pill ${selectedPlatforms.includes(id) ? 'pill-active' : ''}`}
                style={selectedPlatforms.includes(id) ? { '--platform-color': color } : {}}
                onClick={() => togglePlatform(id)}
              >
                <Icon /> {label}
              </button>
            ))}
          </div>
        </section>

        {/* Generate */}
        <div className="sidebar-footer">
          <button className="btn-generate" onClick={handleGenerate} disabled={genSteps?.some((s) => s.status === 'running')}>
            <Zap size={16} />
            Generate with Blotato
          </button>
        </div>
      </aside>

      {/* ── Chat ── */}
      <main className="chat-area">
        <header className="chat-header">
          <div className="chat-header-left">
            <Bot size={20} className="header-bot-icon" />
            <div>
              <h1>AI Agent</h1>
              {selectedClient && (
                <span className="chat-subtitle">
                  {selectedClient.company_name}{selectedClient.domain ? ` · ${selectedClient.domain}` : ''}
                </span>
              )}
            </div>
          </div>
          <div className="header-right">
            <div className="header-badges">
              {selectedContentType && <span className="badge badge-blue">{selectedContentType}</span>}
              {selectedPlatforms.map((p) => <span key={p} className="badge badge-gray">{p}</span>)}
            </div>
            <div className="header-user">
              <span className="user-name">{authUser.name}</span>
              <button className="icon-btn" title="Sign out" onClick={handleLogout}>
                <LogOut size={15} />
              </button>
            </div>
          </div>
        </header>

        <div className="messages">
          {messages.map((msg) => (
            <div key={msg.id} className={`message ${msg.role}`}>
              {msg.role === 'assistant' && <div className="avatar"><Bot size={15} /></div>}
              <div className="bubble">{msg.text}</div>
            </div>
          ))}
          <div ref={chatEndRef} />
        </div>

        <div className="chat-input-bar">
          <textarea
            className="chat-input"
            placeholder="Describe the content you want to generate…"
            value={inputText}
            onChange={(e) => setInputText(e.target.value)}
            onKeyDown={handleKeyDown}
            rows={1}
          />
          <button className="send-btn" onClick={sendMessage} disabled={!inputText.trim()}>
            <Send size={17} />
          </button>
        </div>
      </main>

      {/* ── Modals ── */}
      {showAddClient && <AddClientModal onAdd={handleAddClient} onClose={() => setShowAddClient(false)} />}
      {confirmDelete && (
        <ConfirmModal
          title="Remove Client"
          message={`Are you sure you want to remove "${confirmDelete.name}"? This cannot be undone.`}
          confirmLabel="Yes, Remove"
          onConfirm={() => handleRemoveClient(confirmDelete.id)}
          onClose={() => setConfirmDelete(null)}
        />
      )}
      {genSteps && (
        <GenerateModal
          steps={genSteps}
          result={genResult}
          error={genError}
          onClose={() => { setGenSteps(null); setGenResult(null); setGenError(null); }}
        />
      )}
    </div>
  );
}
